import { useState } from 'react';
import { IconCheck, IconCopy } from '@tabler/icons-react';
import { cn } from '../utils/styles';

const COPY_FEEDBACK_DURATION_MS = 1500;
const ICON_SIZE = 14;

export function CopyButton({ value }: { value: string }) {
  const [copied, setCopied] = useState(false);
  const isDisabled = value === '-';

  const handleCopy = () => {
    if (isDisabled) return;
    navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), COPY_FEEDBACK_DURATION_MS);
  };

  return (
    <button
      type="button"
      onClick={handleCopy}
      disabled={isDisabled}
      className={cn(
        'caddietw-p-1 caddietw-rounded caddietw-border-0 caddietw-transition-colors caddietw-bg-transparent',
        isDisabled
          ? 'caddietw-text-gray-300 caddietw-cursor-default'
          : 'caddietw-text-gray-400 caddietw-cursor-pointer hover:caddietw-text-gray-600 hover:caddietw-bg-gray-100'
      )}
      title={copied ? 'Copied!' : 'Copy to clipboard'}
    >
      {copied ? (
        <IconCheck size={ICON_SIZE} className="caddietw-text-green-500" />
      ) : (
        <IconCopy size={ICON_SIZE} />
      )}
    </button>
  );
}
